import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@services/api.service';

import {
  AuditLogResponse,
} from '@entities/log';
import { Observable } from 'rxjs';
// import {} from '@entities/account';
@Injectable({
  providedIn: 'root',
})
export class LogService {
  constructor(private api: ApiService) {}

  /**
   * Auditログを取得する
   * @returns Auditログ情報
   */
  findAll(
    historyFrom: string,
    historyTo: string,
  ): Observable<AuditLogResponse> {
    const url = `/audit-logs`;
    let params = new HttpParams();
    params = params.set('history_from', historyFrom);
    params = params.set('history_to', historyTo);
    return this.api.get<AuditLogResponse>(url, { params });
  }

  /**
   * Auditログを登録する。
   */
  add(type: string, params?: { [key: string]: string }): Observable<void> {
    const url = `/me/activity`;
    let requestParam = {};
    if (params) {
      requestParam = {'type': type, params}
    } else {
      requestParam = {'type': type}
    }
    return this.api.post<void>(url, requestParam);
    
  }

}
